<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>
    <!-- 1 -->
    <block-label :label="'I.5 PENGELOLAAN KESELAMATAN OPERASI'" />
    <input-form-penilaian-kplh :tables="tableInput.inputForm1" :listInput="listInput.inputForm1" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'kplhStore/SET_KPLH_FORM'" :storeName="'kplhStore'" :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview" />

    <input-form-penilaian-kplh :tables="tableInput.inputForm2" :listInput="listInput.inputForm2" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'kplhStore/SET_KPLH_FORM'" :storeName="'kplhStore'" :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview" />

    <input-form-penilaian-kplh :tables="tableInput.inputForm3" :listInput="listInput.inputForm3" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'kplhStore/SET_KPLH_FORM'" :storeName="'kplhStore'" :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview" />

    <input-form-penilaian-kplh :tables="tableInput.inputForm4" :listInput="listInput.inputForm4" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'kplhStore/SET_KPLH_FORM'" :storeName="'kplhStore'" :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview" />

    <input-form-penilaian-kplh :tables="tableInput.inputForm5" :listInput="listInput.inputForm5" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'kplhStore/SET_KPLH_FORM'" :storeName="'kplhStore'" :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview" />

    <input-form-penilaian-kplh :tables="tableInput.inputForm6" :listInput="listInput.inputForm6" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'kplhStore/SET_KPLH_FORM'" :storeName="'kplhStore'" :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview" />

    <input-form-penilaian-kplh :tables="tableInput.inputForm7" :listInput="listInput.inputForm7" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'kplhStore/SET_KPLH_FORM'" :storeName="'kplhStore'" :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview" />

    <input-form-penilaian-kplh :tables="tableInput.inputForm8" :listInput="listInput.inputForm8" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'kplhStore/SET_KPLH_FORM'" :storeName="'kplhStore'" :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview" />

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Simpan dan Lanjutkan
      </div>
    </div>
  </div>
</template>

<script>
import InputArea from '../../components/forms/input/input-area.vue'
import BlockLabel from '../../components/forms/label/blockLabel.vue'
import PlainLabel from '../../components/forms/label/plainLabel.vue'
import UploadFile from '../../components/forms/input/multiple_upload.vue'
import InputFormPenilaianKplh from '../../components/forms/input-form-penilaian-kplh.vue'
import DescPenilaian from '../../components/desc-penilaian.vue'
export default {
  components: {
    BlockLabel,
    PlainLabel,
    InputArea,
    UploadFile,
    InputFormPenilaianKplh,
    DescPenilaian,
  },
  data() {
    return {
      tableInput: {
        inputForm1: [
          {
            name: 'I.5.1 TENAGA TEKNIS',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm2: [
          {
            name: 'I.5.2 SARANA PRASARANA, INSTALASI & PERALATAN',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm3: [
          {
            name: 'I.5.3 PENGAMANAN INSTALASI',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm4: [
          {
            name: 'I.5.4 KELAYAKAN SPIP',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm5: [
          {
            name: 'I.6 SISTEM IZIN KERJA',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm6: [
          {
            name: 'I.7 PENGELOLAAN PERLINDUNGAN LINGKUNGAN',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm7: [
          {
            name: 'I.8 PROSEDUR KERJA',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm8: [
          {
            name: 'I.9 ALAT PERLINDUNGAN DIRI',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
      },
      listInput: {
        inputForm1: [
          {
            type: 'form',
            name:
              'Lampirkan rincian tenaga teknis yang dimiliki perusahaan (jumlah serta tugas & tanggung jawabnya) contoh nya: ahli listrik, juru las, juru ukur, juru ledak dll.',
            subname: 'Tinggi',
            bobot: '3',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i51_1',
            inputStore: 'note_i51_1',
            fileStore: 'attachment_i51_1',
            tooltipText: '- Rincian memuat: Nama, peran Tenaga Teknis Pertambangan dan sertifikasi/kompetensi<br>- Daftar mencakup semua Tenaga Teknis sesuai kebutuhan operasional bidang yang diajukan',
            internalNoteStore: 'internal_note_i51_1',
          },
          {
            type: 'form',
            name: 'Lampirkan salinan bukti kompetensi tenaga teknis (minimal 2)',
            subname: 'Tinggi',
            bobot: '3',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i51_2',
            inputStore: 'note_i51_2',
            fileStore: 'attachment_i51_2',
            tooltipText: 'Melampirkan 2 salinan bukti kompetensi yang sesuai dengan persyaratan pada I.5.1.1',
            internalNoteStore: 'internal_note_i51_2',
          },
        ],
        inputForm2: [
          {
            type: 'form',
            name:
              'Lampirkan daftar sarana, prasarana, instalasi, dan peralatan (SPIP) yang dimiliki perusahaan',
            subname: 'Rendah',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i52_1',
            inputStore: 'note_i52_1',
            fileStore: 'attachment_i52_1',
            tooltipText: 'Daftar memuat semua SPIP utama yang digunakan sesuai bidang yang didaftarkan',
            internalNoteStore: 'internal_note_i52_1',
          },
          {
            type: 'form',
            name: 'Lampirkan prosedur pemeliharaan untuk setiap jenis SPIP',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i52_2',
            inputStore: 'note_i52_2',
            fileStore: 'attachment_i52_2',
            tooltipText: 'Prosedur untuk pemeliharaan semua SPIP utama yang digunakan sesuai bidang yang didaftarkan',
            internalNoteStore: 'internal_note_i52_2',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan program pemeliharaan rutin SPIP (minimal untuk 4 jenis SPIP). Jika program pemeliharaan dilakukan oleh pihak ketiga, jelaskan pihak ketiga yang melakukan pemeliharaan rutin SPIP',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i52_3',
            inputStore: 'note_i52_3',
            fileStore: 'attachment_i52_3',
            tooltipText: 'Program pemeliharaan rutin untuk 4 jenis SPIP (tidak hanya menyebutkan jadwal PM secara umum namun dijelaskan jenis pemeriksaannya seperti mechanical, electrical, dsb.)',
            internalNoteStore: 'internal_note_i52_3',
          },
        ],
        inputForm3: [
          {
            type: 'form',
            name:
              'Lampirkan salinan hasil identifikasi kebutuhan pengamanan untuk instalasi (contoh: instalasi listrik, pneumatik/hidrolik, bahan bakar cair, air, komunikasi, proteksi kebakaran, gas)',
            subname: 'Kritis',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i53_1',
            inputStore: 'note_i53_1',
            fileStore: 'attachment_i53_1',
            tooltipText: 'Identifikasi kebutuhan pengamanan instalasi memuat seluruh instalasi yang digunakan sesuai bidang yang didaftarkan',
            internalNoteStore: 'internal_note_i53_1',
          },
          {
            type: 'form',
            name:
              'Lampirkan 1 (satu) salinan evaluasi sistem pengamanan instalasi',
            subname: 'Kritis',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i53_2',
            inputStore: 'note_i53_2',
            fileStore: 'attachment_i53_2',
            tooltipText: 'Evaluasi meliputi: Pemasangan, pemeliharaan, dan tenaga teknis yang melakukan pemasangan & pemeliharaan pengamanan instalasi',
            internalNoteStore: 'internal_note_i53_2',
          },
        ],
        inputForm4: [
          {
            type: 'form',
            name: 'Lampirkan prosedur pengajuan kelayakan SPIP',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i54_1',
            inputStore: 'note_i54_1',
            fileStore: 'attachment_i54_1',
            tooltipText: 'Prosedur meliputi: Periode pengujian (program & jadwal), tenaga teknis yang melakukan pengujian dan tindak lanjut hasil pengujiannya (pengujian meliputi commissioning & kalibrasi)',
            internalNoteStore: 'internal_note_i54_1',
          },
          {
            type: 'form',
            name: 'Lampirkan salinan standar kelayakan SPIP',
            subname: 'Kritis',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i54_2',
            inputStore: 'note_i54_2',
            fileStore: 'attachment_i54_2',
            tooltipText: 'Standar kelayakan semua jenis SPIP utama yang digunakan sesuai bidang yang didaftarkan  (pengujian meliputi commissioning & kalibrasi)',
            internalNoteStore: 'internal_note_i54_2',
          },
          {
            type: 'form',
            name: 'Lampirkan salinan pelaksanaan uji kelayakan SPIP (minimal 3 buah) ',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i54_3',
            inputStore: 'note_i54_3',
            fileStore: 'attachment_i54_3',
            tooltipText: '3 salinan pelaksanaan uji kelayakan SPIP (pengujian meliputi commissioning & kalibrasi)',
            internalNoteStore: 'internal_note_i54_3',
          },
        ],
        inputForm5: [
          {
            type: 'form',
            name:
              'Lampirkan prosedur terkait izin kerja khusus. Jika prosedur tidak ada, lampirkan semua jenis formulir izin kerja khusus',
            subname: 'Tinggi',
            bobot: '3',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i6_1',
            inputStore: 'note_i6_1',
            fileStore: 'attachment_i6_1',
            tooltipText: 'Prosedur / form meliputi: Jenis IKK (sesuai dengan bidang yang didaftarkan), formulir yang digunakan, pihak-pihak yang terlibat pada IKK (pembuat, pemeriksa, penyetuju), dan persyaratan wajib untuk setiap jenis IKK',
            internalNoteStore: 'internal_note_i6_1',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan formulir izin kerja khusus yang pernah dilakukan',
            subname: 'Tinggi',
            bobot: '3',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i6_2',
            inputStore: 'note_i6_2',
            fileStore: 'attachment_i6_2',
            tooltipText: 'Formulir sesuai dengan I.6.1, pengisian benar dan sesuai dengan prosedur',
            internalNoteStore: 'internal_note_i6_2',
          },
        ],
        inputForm6: [
          {
            type: 'form',
            name:
              'Lampirkan prosedur terkait pengelolaan perlindungan lingkungan hidup',
            subname: 'Tinggi',
            bobot: '4',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i7_1',
            inputStore: 'note_i7_1',
            fileStore: 'attachment_i7_1',
            tooltipText: 'Prosedur meliputi: Upaya penanganan / penanggulangan dampak (pencemaran / perusakan lingkungan) dari seluruh kegiatan dan pemantauan/monitoring lingkungan yang relevan',
            internalNoteStore: 'internal_note_i7_1',
          },
          {
            type: 'form',
            name: 'Lampirkan dokumen izin lingkungan yang dimiliki perusahaan',
            subname: 'Sedang',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i7_2',
            inputStore: 'note_i7_2',
            fileStore: 'attachment_i7_2',
            tooltipText: 'melampirkan seluruh izin lingkungan yang dengan bidang usaha yang diajukan',
            internalNoteStore: 'internal_note_i7_2',
          },
        ],
        inputForm7: [
          {
            type: 'form',
            name:
              'Lampirkan daftar seluruh prosedur pengendalian operasional yang dimiliki perusahaan (seluruh prosedur hingga Analisa Kerja Aman / JSA dan Instruksi Kerja Aman)',
            subname: 'Rendah',
            bobot: '4',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i8_1',
            inputStore: 'note_i8_1',
            fileStore: 'attachment_i8_1',
            tooltipText: 'Daftar prosedur memuat semua prosedur operasional sesuai bidang yang didaftarkan',
            internalNoteStore: 'internal_note_i8_1',
          },
          {
            type: 'form',
            name: 'Lampirkan prosedur pengendalian dokumen',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i8_2',
            inputStore: 'note_i8_2',
            fileStore: 'attachment_i8_2',
            tooltipText: 'Prosedur meliputi:<br>- Persetujuan pengeluaran, penerbitan dan pengelolaan dokumen<br>- Perubahan dan modifikasi dokumen, serta<br>- Identifikasi dan pengelolaan dokumen yang berasal dari luar yang terkait',
            internalNoteStore: 'internal_note_i8_2',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan bukti sosialisasi prosedur pengendalian operasional kepada karyawan (minimal 3 bukti)',
            subname: 'Sedang',
            bobot: '3',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i8_3',
            inputStore: 'note_i8_3',
            fileStore: 'attachment_i8_3',
            tooltipText: '3 bukti sosialisasi prosedur pengendalian operasional kepada karyawan',
            internalNoteStore: 'internal_note_i8_3',
          },
        ],
        inputForm8: [
          {
            type: 'form',
            name: 'Lampirkan prosedur tentang penggunaan APD di perusahaan',
            subname: 'Tinggi',
            bobot: '3',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i9_1',
            inputStore: 'note_i9_1',
            fileStore: 'attachment_i9_1',
            tooltipText: 'Prosedur meliputi:<br>- Kebutuhan APD yang sesuai dengan jenis pekerjaan dan bahaya yang timbul<br>- Penyediaan APD dengan jumlah yang memadai secara cuma-cuma, dan<br>- Pelatihan untuk pekerja terkait dengan fungsi, manfaat, penggunaan, dan perawatan APD',
            internalNoteStore: 'internal_note_i9_1',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan daftar distribusi semua jenis APD, baik APD umum maupun APD khusus untuk pekerjaan tertentu',
            subname: 'Rendah',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i9_2',
            inputStore: 'note_i9_2',
            fileStore: 'attachment_i9_2',
            tooltipText: 'Daftar distribusi APD umum kepada seluruh pekerja dan APD khusus kepada pekerja tertentu',
            internalNoteStore: 'internal_note_i9_2',
          },
        ],
      },
    }
  },
  computed: {
    is_hse_validation() {
      return this.$store.state.kplhStore.is_hse_validation
    },
    is_preview() {
      return this.$store.state.kplhStore.is_preview
    },
  },
  methods: {
    goBack() {
      this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupi1' })
    },
    goNext() {
      this.$store.commit('kplhStore/SUBMIT_PENILAIAN_FOR_DRAFT', {
        onSuccess: () => {
          this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupjm' })

        }
      })
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
